import Joi from "joi";
import { setValidationMessages } from "./validationMessages";

export const schemaStudentText = (propText) => {
  const arr = propText.split("_");
  return {
    [arr[2]]: Joi.string()
      .min(1)
      .max(255)
      .required()
      .messages(setValidationMessages(["string", "required"])),
  };
};

export const schemaStudentSelect = (propText) => {
  const arr = propText.split("_");
  return {
    [arr[2]]: Joi.number()
      .integer()
      .messages(setValidationMessages(["number", "required"])),
  };
};

export const schemaProdep = {
  id_professor: Joi.string()
    .min(3)
    .max(255)
    .required()
    .messages(setValidationMessages(["string", "required"])),
  grade: Joi.number()
    .integer()
    .messages(setValidationMessages(["number", "required"])),
  professor: Joi.string()
    .min(3)
    .max(255)
    .required()
    .messages(setValidationMessages(["string", "required"])),
  program: Joi.number()
    .integer()
    .messages(setValidationMessages(["number", "required"])),
  region: Joi.number()
    .integer()
    .messages(setValidationMessages(["number", "required"])),
  procedure: Joi.number()
    .integer()
    .messages(setValidationMessages(["number", "required"])),
  students: Joi.array()
    .items(
      Joi.object().keys({
        matricula: Joi.string()
          .min(3)
          .max(255)
          .required()
          .messages(setValidationMessages(["string", "required"])),
        student: Joi.string()
          .min(3)
          .max(255)
          .required()
          .messages(setValidationMessages(["string", "required"])),
        title: Joi.string()
          .min(3)
          .max(255)
          .required()
          .messages(setValidationMessages(["string", "required"])),
        type: Joi.number()
          .integer()
          .messages(setValidationMessages(["number", "required"])),
        result: Joi.string()
          .min(1)
          .max(255)
          .required()
          .messages(setValidationMessages(["string", "required"])),
        date: Joi.string()
          .required()
          .messages(setValidationMessages(["string", "required"])),
      })
    )
    .min(1),
};
